import styled from "styled-components";
import React from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodRecipet } from "../../assets/Podcast/PodRecipet";
import { gql, useQuery } from "@apollo/client";
import { LoadingWLogo } from "../../components/LoadingWLogo";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const StyleCss = styled.div`
  .campaign {
    margin: 7.5px;
    padding: 5px 10px;
    border: 1px solid var(--n-grey-3);
    background-color: var(--n-grey-1);
    border-radius: 8px;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-decoration: none;
    color: var(--n-text-2);
    transition: all 0.15s ease-in-out;
    :hover {
      border: 1px solid var(--n-grey-7);
      color: var(--n-text-1);
    }
    &.header {
      border: none;
      background-color: transparent;
      margin: 7.5px 7.5px 0;
      font-weight: 500;
      .column {
        padding: 0.5rem 0.5rem 0;

      }
    }
    .column {
      padding: 0.5rem;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    .contract {
      padding: 0.7rem 1rem;
      display: flex;
      box-shadow: 0px 4px 8px -2px #00000040;
      border-radius: 4px;
      text-decoration: none;
      color: inherit;
      transition: all 0.2s ease-in-out;
      :hover {
        background-color: #00000010;
      }
      .expand {
        flex-grow: 1;
      }
      .date {
        width: 25%;
      }
      .more-info {
        color: blue;
        cursor: pointer;
      }
      &.header {
        font-weight: 700;
        :hover {
          background-color: inherit;
        }
      }
    }
  }
`;


export const PayrollList_Query = gql`
  query HoghoghQuery{
    getListHoghogh {
      _id
      Hogog_CodPer
      Comp_Code
      MarHaz_Code
      MarHaz_Detail_Code
      Hogog_Sal
      Hogog_Mah
      Hogog_List
      Hogog_Rooz
      Hogog_Maza_Mab
      Hogog_Koso_Mab
      Hogog_Daryafti
      Hogog_Finish
      Hogog_Vazhiat
      Hogog_Morakhasi
      Hokme_No
      Hogog_Date_End
      ArzRate_code_Bimeh
      ArzRate_code_Malyat
      ArzRate_code_Hogog
      Hogog_Mab1_Flag
      Hogog_Mash_Bimeh
      Hogog_Mash_Malyat
      Sanad_shosan
      Sanad_shosan_Pardakht
      Hogog_AhdiExtra
      Hogog_SanavatExtra
      Hogog_Comment
      Hogog_Tamam_Saati
    }
  }
`

function WorkPagePayroll(props) {
  const payroll = useQuery(PayrollList_Query, {
    fetchPolicy: "network-only"
  });
  if(payroll.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
            <div className="title">
              <div className="icon"><PodRecipet/></div>
              <div className="text">Payroll</div>
            </div>
        </div>
        <div className="content">
          <LoadingWLogo/>
        </div>
      </StyleCss>
    )
  }
  const makeHoghoghs = () => {
    let list = [];
    if(payroll.data && payroll.data.getListHoghogh){
      list = payroll.data.getListHoghogh;
    }
    return list.map((v, i) => {
      return (
        <Link to={"/work/payroll/"+v._id} className="contract" key={i}>
          <div className="date">{v.Hogog_Sal}</div>
          <div className="date">{months[parseInt(v.Hogog_Mah)].en}</div>
          <div className="date">{(companies[parseInt(v.MarHaz_Code)] ? companies[parseInt(v.MarHaz_Code)].en: "other")}</div>
          <div className="expand"></div>
          <div className="more-info">
            {/* <Link to={"/work/payroll/"+v._id}> */}
              more info
            {/* </Link> */}
          </div>
        </Link> 
      )
    })
  }
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodRecipet/></div>
            <div className="text">Payroll</div>
          </div>
      </div>
      <div className="content">
        <div className="contract header">
          <div className="date">Year</div>
          <div className="date">Month</div>
          <div className="date">Company</div>
          <div className="more-info"></div>
        </div>
        {makeHoghoghs()}
        {/* <div className="contract">
          <div className="date">1402/02/01</div>
          <div className="date">1402/06/01</div>
          <div className="date">89,550,245 {"(Rls)"}</div>
          <div className="expand"></div>
          <div className="more-info"></div>
        </div> */}
      </div>
    </StyleCss>
  )
}
export default WorkPagePayroll;


export const months = {
  1: {
    fa: "فروردین",
    en: "Farvardin"
  },
  2: {
    fa: "اردیبهشت",
    en: "Ordibehesht"
  },
  3: {
    fa: "خرداد",
    en: "Khordad"
  },
  4: {
    fa: "تیر",
    en: "Tir"
  },
  5: {
    fa: "مرداد",
    en: "Mordad"
  },
  6: {
    fa: "شهریور",
    en: "Shahrivar"
  },
  7: {
    fa: "مهر",
    en: "Mehr"
  },
  8: {
    fa: "آبان",
    en: "Aban"
  },
  9: {
    fa: "آذر",
    en: "Azar"
  },
  10: {
    fa: "دی",
    en: "Dey"
  },
  11: {
    fa: "بهمن",
    en: "Bahman"
  },
  12: {
    fa: "اسفند",
    en: "Esfand"
  },
  13: {
    fa: "عیدی",
    en: "Reward"
  },
  14: {
    fa: "سنوانت",
    en: "Sanavat"
  }
}

export const companies = {
  1: {
    fa: "دفتر مرکزی",
    en: "central office",
  },
  2: {
    fa: "شرکت اریکسون",
    en: "Ericsson",
  },
  3: {
    fa: "پیشاهنگ",
    en: "Pishahang",
  },
  4: {
    fa: "هوآوی",
    en: "Huawei",
  },
  5: {
    fa: "پروژه IT",
    en: "IT Project",
  },
  6: {
    fa: "هیراد",
    en: "Hirad",
  },
  7: {
    fa: "پنتا",
    en: "penta",
  },
  8: {
    fa: "شبکه متقارن",
    en: "Symmetric Network",
  },
  9: {
    fa: "کنکاش",
    en: "kankash",
  },
  10: {
    fa: "دنیلی",
    en: "Danyeli",
  },
  11: {
    fa: "دیان گستر پارسیان",
    en: "Diyan Gostar Parsiyan",
  },
  12: {
    fa: "نوکیا",
    en: "Nokia",
  },
  13: {
    fa: "رایتل",
    en: "Rightel",
  },
  14: {
    fa: "رایتل",
    en: "Rightel",
  },
  15: {
    fa: "هواپیمایی قطر",
    en: "Qatar Airways",
  },
  27: {
    fa: "نشریه فراز اندیشان",
    en: "Faraz Andishan Magazine",
  },
  28: {
    fa: "ادونتج",
    en: "Advantage",
  },
  41: {
    fa: "نقش اول کیفیت",
    en: "NAK",
  },
  42: {
    fa: "ویستا",
    en: "Vista",
  },
  98: {
    fa: "بیمه نشده ها",
    en: "No Bimeh",
  },
  99: {
    fa: "سایر",
    en: "others",
  }
};